import { render, staticRenderFns } from "./StudentPolicyForm.vue?vue&type=template&id=1c0691a6"
import script from "./StudentPolicyForm.vue?vue&type=script&lang=js"
export * from "./StudentPolicyForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports